import Link from 'next/link';

import cn from '@/lib/clsxm';

import Card from '@/components/@base/card';
import Container from '@/components/@base/container';
import { Heading } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';
import XImage from '@/components/@base/x-image';
import CopyLink from '@/components/shared/components/developer-discount-codes/copy-link';
import PriceView from '@/components/shared/components/price-view';

import VendorVoucherModel from '@/models/vendor-voucher.model';

export default function DiscountedProductCard({ product }: { product: VendorVoucherModel }) {
  return (
    <Card noShadow noBorder className=' bg-[#D9D9D9] bg-opacity-20 '>
      <Container className='flex flex-row lg:grid lg:grid-cols-2 '>
        <Container className='flex flex-1 flex-col  justify-center gap-5  p-6'>
          <Heading
            type={HEADING_TYPE.H3}
            className='text-[15px] font-medium leading-8 tracking-tighter text-[#404040] lg:text-[17px]'
          >
            <Link
              href={`/web/${product?.slug}`}
              className='hover:text-[#ff9606]'
              prefetch={false}
            >
              {product?.title}
            </Link>
          </Heading>
          <Container>
            <PriceView
              price={product.regularPrice}
              priceClassName='text-[18px] font-medium text-[#4D4A4A] leading-6'
              currencyClassName='font-light text-[13px] text-[#8C8C8C]'
              lastPriceClassName='font-medium text-[16px] text-[#B1B1B1] line-through leading-9'
            />
          </Container>
          <Container className='hidden md:flex'>
            <CopyLink code={product.code} />
          </Container>
        </Container>
        <Container className='relative m-[10px] hidden  justify-end md:flex '>
          <XImage
            className={cn('rounded-md ')}
            width={266}
            height={239}
            alt={product?.thumbnail?.title || ''}
            src={product?.thumbnail?.publicLink || ''}
          />
        </Container>
        <Container className='relative m-5  md:hidden '>
          <XImage
            className={cn('rounded-md object-center')}
            width={85}
            height={100}
            alt={product?.icon?.title || ''}
            src={product?.icon?.publicLink || ''}
          />
        </Container>
      </Container>
      <Container className='mx-auto  flex w-full md:hidden'>
        <CopyLink code={product.code} />
      </Container>
    </Card>
  );
}
